import { render } from "./PreviousOrder.vue?vue&type=template&id=7f4db068"
import script from "./PreviousOrder.vue?vue&type=script&lang=js"
export * from "./PreviousOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__